import type { CityConfig } from "../city-template/types";

export const mechanicsvilleVaConfig: CityConfig = {
  city: "Mechanicsville",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "mechanicsville-va",
  route: "/cities/mechanicsville-va",
  title: "Emergency Passport Mechanicsville, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Mechanicsville, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Mechanicsville, Hanover County, and the Richmond East Corridor. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Mechanicsville, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Hanover County, Atlee, or the Richmond East Corridor? We help Mechanicsville travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Mechanicsville%20Virginia%20suburban%20landscape%20with%20rolling%20green%20farmland%20and%20historic%20rural%20roads%2C%20beautiful%20suburban%20neighborhoods%20along%20Route%20360%20with%20mature%20trees%20and%20traditional%20Virginia%20homes%2C%20warm%20afternoon%20golden%20light%20with%20open%20fields%20and%20pine%20forests%2C%20professional%20photography%20showcasing%20a%20peaceful%20Richmond%20suburb%20with%20agricultural%20heritage%20and%20modern%20suburban%20development%2C%20no%20people%20visible%2C%20scenic%20rural-suburban%20landscape%20with%20expansive%20green%20fields%20and%20clear%20blue%20sky&width=1800&height=700&seq=mechanicsville-va-hero-001&orientation=landscape",
  heroImageAlt: "Mechanicsville Virginia suburban landscape with rolling green farmland and historic rural roads near Richmond",
  geoPosition: "37.6088;-77.3733",
  geoPlacename: "Mechanicsville, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 105 miles north of Mechanicsville via I-295 and I-95",
  },
  nearbyCitiesZips: [
    { name: "Mechanicsville", zips: "23111, 23116" },
    { name: "Hanover County", zips: "23005, 23015, 23047, 23069, 23111, 23116, 23146" },
    { name: "Atlee", zips: "23116" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Ashland", zips: "23005" },
    { name: "Glen Allen", zips: "23059, 23060" },
    { name: "Short Pump", zips: "23233" },
    { name: "Midlothian", zips: "23112, 23113, 23114" },
    { name: "Henrico", zips: "23075, 23228, 23229, 23231, 23233, 23238, 23294" },
    { name: "Tuckahoe", zips: "23229, 23238" },
    { name: "Highland Springs", zips: "23075" },
    { name: "Sandston", zips: "23150" },
    { name: "Studley", zips: "23162" },
    { name: "Hanover", zips: "23069" },
    { name: "Montpelier", zips: "23192" },
    { name: "Colonial Heights", zips: "23834" },
    { name: "Petersburg", zips: "23803, 23804, 23805, 23806" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Richmond East Corridor" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Richmond East Corridor Hub", desc: "Serving Mechanicsville, Hanover County, Atlee, and the Richmond eastern suburbs" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Richmond VA passport services", route: "/cities/richmond-va" },
    { name: "Ashland VA passport services", route: "/cities/ashland" },
    { name: "Glen Allen VA passport services", route: "/cities/glen-allen-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Mechanicsville remotely via secure courier. We do not have a walk-in office in Mechanicsville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Mechanicsville and Richmond East Corridor travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Mechanicsville and the Richmond East Corridor including Hanover County, Atlee, Ashland, Highland Springs, and the greater Richmond eastern suburbs",
  serviceAreaIntro: "From the historic Battlefield of Mechanicsville to the quiet suburban streets of Atlee, from the rural charm of Hanover County to the growing communities along Route 360, from the family-friendly neighborhoods near Lee-Davis High School to the bustling corridors near Richmond — Fast Passport Center serves every corner of Mechanicsville and the Richmond East Corridor. We regularly help travelers from Hanover County, Ashland, and Highland Springs get their passports fast.",
  nearbyCitiesIntro: "We serve all Mechanicsville neighborhoods and the Richmond East Corridor including Hanover County, Atlee, Ashland, Glen Allen, Richmond, and Highland Springs.",
  howItWorksIntro: "Most Mechanicsville travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Mechanicsville travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Mechanicsville and Richmond East Corridor travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Mechanicsville? Here are the most common ones we hear from Richmond East Corridor travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Mechanicsville international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Thomas C.",
      location: "Mechanicsville, VA",
      rating: 5,
      text: "I live in the Atlee area and needed an emergency passport for a business trip to Frankfurt with 4 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Bell Creek Road and it was completely seamless. No need to drive to DC.",
      service: "Emergency Passport",
    },
    {
      name: "Patricia L.",
      location: "Hanover County, VA",
      rating: 5,
      text: "As a Hanover County resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 4 days. The convenience for Richmond area families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Andrew M.",
      location: "Mechanicsville, VA",
      rating: 5,
      text: "First passports for my two kids before a family trip to Disney World in Orlando. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 5 days. For busy Mechanicsville families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Deborah S.",
      location: "Mechanicsville, VA",
      rating: 5,
      text: "Lost my passport 2 days before a wedding in Mexico. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my vacation. Mechanicsville residents need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "mechanicsville-va-1",
      name: "Mechanicsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Mechanicsville",
      state: "VA",
      zip: "23111",
      phone: "(804) 730-9151",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Mechanicsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Mechanicsville facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "mechanicsville-va-2",
      name: "Ashland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Ashland",
      state: "VA",
      zip: "23005",
      phone: "(804) 798-9211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ashland, north of Mechanicsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Ashland and Hanover County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "mechanicsville-va-3",
      name: "Richmond Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Richmond",
      state: "VA",
      zip: "23219",
      phone: "(804) 343-1126",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Richmond, south of Mechanicsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves downtown Richmond. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "mechanicsville-va-4",
      name: "Hanover County Clerk",
      type: "County Clerk",
      address: "P.O. Box 39",
      city: "Hanover",
      state: "VA",
      zip: "23069",
      phone: "(804) 365-6151",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Hanover County",
      website: "https://www.hanovercounty.gov",
      websiteLabel: "Hanover County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "mechanicsville-va-5",
      name: "Glen Allen Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Glen Allen",
      state: "VA",
      zip: "23059",
      phone: "(804) 672-2156",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Glen Allen, west of Mechanicsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Glen Allen and western Henrico. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "mechanicsville-va-6",
      name: "Highland Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Highland Springs",
      state: "VA",
      zip: "23075",
      phone: "(804) 328-3631",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Highland Springs, near Mechanicsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Henrico. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Mechanicsville photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Richmond area acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Mechanicsville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Mechanicsville families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Mechanicsville travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Mechanicsville or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Mechanicsville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Mechanicsville before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Mechanicsville for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Richmond East Corridor." },
    { q: "How fast can I renew my passport in Mechanicsville?", a: "Fast Passport Center offers fast passport renewal in Mechanicsville in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Mechanicsville?", a: "The nearest regional passport agency to Mechanicsville is the Washington Passport Agency, located approximately 105 miles north in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Mechanicsville." },
    { q: "Can I get a same-day passport appointment near Mechanicsville?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Mechanicsville residents." },
    { q: "Can I expedite a child passport in Mechanicsville?", a: "Yes. Fast Passport Center expedites child passports in Mechanicsville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Mechanicsville and Hanover County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Mechanicsville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Mechanicsville?", a: "With Fast Passport Center's emergency courier service, Mechanicsville travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Mechanicsville?", a: "Popular options include the Mechanicsville Post Office (23111), Ashland Post Office (23005), Richmond Main Post Office (23219), Glen Allen Post Office (23059), and Highland Springs Post Office (23075). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Atlee, Hanover County, or Highland Springs?", a: "We serve the entire Richmond East Corridor including Atlee, Hanover County, Highland Springs, Ashland, and Sandston. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Mechanicsville?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Mechanicsville", address: "7379 Bell Creek Rd, Mechanicsville, VA 23111", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Mechanicsville", address: "7255 Bell Creek Rd, Mechanicsville, VA 23111", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Ashland", address: "101 S Washington Hwy, Ashland, VA 23005", hours: "Mon-Sun: 8AM-10PM" },
    { name: "CVS Pharmacy — Richmond", address: "1800 W Broad St, Richmond, VA 23220", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Glen Allen", address: "10800 W Broad St, Glen Allen, VA 23060", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Richmond", address: "1800 W Broad St, Richmond, VA 23220", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Mechanicsville",
      address: "7401 Bell Creek Rd, Mechanicsville, VA 23111",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Richmond",
      address: "2300 W Broad St, Richmond, VA 23220",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Ashland",
      address: "101 S Railroad Ave, Ashland, VA 23005",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Hanover County and Ashland. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Approximately 15 miles south of Mechanicsville",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "The closest major airport to Mechanicsville. International and domestic flights. Accessible via I-295.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 105 miles north of Mechanicsville",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Major international hub for Richmond East Corridor travelers. Accessible via I-295 and I-95.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "IAD",
      name: "Washington Dulles International Airport",
      distance: "Approximately 125 miles north of Mechanicsville",
      address: "1 Saarinen Cir, Sterling, VA 20166",
      note: "Major international hub for long-haul flights. Accessible via I-295 and I-495.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Approximately 85 miles southeast of Mechanicsville",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "Regional alternative for southeastern Virginia. Accessible via I-64.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options for Mechanicsville and Hanover County residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Hanover County Circuit Court Clerk. Certified copies available for name changes.", url: "https://www.hanovercounty.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Hanover County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.hanovercounty.gov/" },
  ],
};